import {COLORS, bp, Z} from 'core/styles';
import styled from 'styled-components';

export const ActionPanelContainer = styled.div`
    .action-panel {
        border-radius: 8px;
        background: #fff;
        /* Elevation/300 */
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.3),
            0px 4px 8px 3px rgba(0, 0, 0, 0.15);

        width: 200px;
        margin: 16px auto;
        ${(props) => (props.$css ? props.$css : '')}
    }
`;
